module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "ContractSignatureView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ContractSignatureView!./src/pages/Shop/Member/Agreements/ContractSignature/index.js
// module id = 951
// module chunks = 438